<script>
    export default {
        name: 'normal-input',
        props: {
            value: [String, Number],
            resize: Object,
            disabled: Boolean,
            readonly: Boolean,
            isAutoWidth: Boolean,
            textAlign:{
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: ''
            },
            width: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: 'text'
            },
            autocomplete: {
                type: String,
                default: 'off'
            },

            suffixIcon: String,
            prefixIcon: String,
            clearable: {
                type: Boolean,
                default: false
            },
            validator: {
                default () {
                    return {};
                },
                require: false,
            },
            showPassword: {
                type: Boolean,
                default: false
            },
            showError: {
                type: Boolean,
                default: false
            },
            marginLeft: {
                default: 0,
                required: false
            },
            maxlength:{
                default: '',
                required: false
            },
            min:{
                default: '',
                required: false
            },
            max:{
                default: '',
                required: false
            },
            marginRight: {
                default: 0,
                required: false
            },
            float: {
                default: 'left',
                required: false
            },
            placeholder: {
                default: '',
                required: false,
                type: String
            },
            autofocus: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            compIptStyle() {
                return {
                    'text-align': this.textAlign
                }
            },
            curStyle () {
                return {
                    'margin-left': this.marginLeft * this.$cStyle.horizonMargin + 'px',
                    'margin-right': this.marginRight * this.$cStyle.horizonMargin + 'px',
                    'float': this.float,
                    'width': this.isAutoWidth ? this.autoWidth : this.width
                };
            },
            comSuffixIcon () {
                return this.showVisibleError ? '&#xe6a7;' : (
                    this.showVisiblePassword ?
                        (this.passwordVisible ? '&#xe6a6;' : '&#xe66a;') : (this.clearable ?
                        (this.showClearable ?
                            '&#xe68e;' : '') : this.suffixIcon)
                );

            },
            showClearable () {
                return this.clearable &&
                    !this.disabled &&
                    !this.readonly &&
                    (this.focused || this.hovering) &&
                    this.value;
            },
            showVisiblePassword () {
                return this.showPassword &&
                    !this.disabled &&
                    !this.readonly &&
                    (this.focused || this.value);
            },
            showVisibleError () {
                return this.showError &&
                    !this.isPassValidator &&
                    !this.disabled &&
                    !this.readonly &&
                    !this.focused;
            }
        },
        model: {
            prop: 'value',
            event: 'input'
        },
        data () {
            return {
                focused: false,
                hovering: false,
                passwordVisible: false,
                isPassValidator: true,
                autoWidth: 'auto'
            };
        },
        watch: {
            value (v) {
                this.setAutoWidth(v);
            },

            autofocus(val) {
                const vmodel = this
                setTimeout(function () {
                    if (val) {
                        vmodel.$refs.ipt.focus()
                    }
                })
            }
        },
        methods: {
            setAutoWidth (v) {
                if (this.isAutoWidth && this.value && this.$refs.pre) {
                    this.$refs.pre.innerHTML = v;
                    const $ipt = this.$refs.ipt;
                    const style = window.getComputedStyle($ipt, false);
                    const widthVal = this.$refs.pre.getBoundingClientRect().width + (parseInt(style.paddingLeft) + parseInt(style.paddingRight) + parseInt(style.borderLeftWidth) + parseInt(style.borderRightWidth));
                    this.autoWidth = `${Math.ceil(widthVal)}px`;
                }
            },
            handlePrefixSuffixIcon (type) {
                if (this.disabled) {
                    return;
                }
                if (type === 'suffix' && this.showVisiblePassword) {
                    this.handleShowPwd();
                } else if (type === 'suffix' && this.showClearable) {
                    this.$emit('clear');
                    this.$refs.ipt.value = '';
                    this.handleInput({target: this.$refs.ipt});
                    this.handleChange({target: this.$refs.ipt});
                }
                this.$emit(`${type}Click`, this.value);
            },
            handleBlur ($e) {
                this.focused = false;
                this.$emit('blur', $e);
                this.handleValidator();
            },
            handleValidator () {
                if (!this.validator) {
                    return;
                }
                let funcArray = [];
                let result = true;
                if (this.validator instanceof Array) {
                    funcArray = this.validator;
                } else if (typeof this.validator === 'object') {
                    funcArray = Object.values(this.validator);
                } else if (typeof this.validator === 'function') {
                    funcArray = [this.validator];
                } else {
                    this.$emit('validator', [true]);
                    this.$emit('checkResult', [true]);
                }
                let resultArray = []
                resultArray = funcArray.map(fuc => fuc(this.value))
                funcArray = resultArray.filter(v => !v);
                result = !funcArray.length;
                this.isPassValidator = result;
                this.$emit('validator', funcArray);
                this.$emit('checkResult', resultArray);
            },
            handleFocus ($e) {
                if (this.readonly && this.$util.isIE()) {
                    this.$refs.ipt.blur();
                }
                this.focused = true;
                this.$emit('focus', $e);
            },
            handleInput ($e) {
                if (!this.readonly && !this.disabled) {
                    this.$emit('input', $e.target.value);
                }
            },
            handleShowPwd () {
                this.passwordVisible = !this.passwordVisible;
            },
            handleChange (event) {
                this.$emit('change', event.target.value);
            },
            handleKeyup(type, event){
                this.$emit('keyup:' + type, event.target.value);
            },
            setIptValue (val) {
                if (this.type === 'textarea') {
                    this.$refs.textarea.value = val;
                } else {
                    this.$refs.ipt.value = val;
                }
            }
        },
        mounted () {
            setTimeout(() => {
                this.setAutoWidth(this.value);
            });
        }
    };
</script>
<template>
    <div :style="curStyle"
         :class="[type === 'textarea' ? 'normal-textarea' : 'normal-input',
                    (comSuffixIcon || clearable) ? 'normal-input-suffix' : '',
                    prefixIcon ? 'normal-input-prefix' : '',
                    showVisibleError ? 'danger' : '',
                    {disabled: disabled}
                    ]"
         @mouseenter="hovering = true"
         @mouseleave="hovering = false"
    >
        <pre style="position: absolute;left: -1000000px;font-size: 14px;" ref="pre"></pre>
        <template v-if="type !== 'textarea'">
            <span class="normal-input__prefix"
                  v-show="prefixIcon"
            >
                  <i v-html="prefixIcon" @click="handlePrefixSuffixIcon('prefix')"></i>
            </span>
            <input :type="showPassword ? (passwordVisible ? 'text' : 'password') : type"
                   :style="compIptStyle"
                   :name="name"
                   ref="ipt"
                   :value="value"
                   :unselectable="readonly || disabled"
                   :autocomplete="autocomplete"
                   :autofocus="autofocus"
                   :placeholder="placeholder"
                   :readonly="readonly"
                   :disabled="disabled"
                   :min='min'
                   :max='max'
                   @blur="handleBlur"
                   @input="handleInput"
                   @focus="handleFocus"
                   @change="handleChange"
                   @keyup.enter="handleKeyup('enter', $event)"
                   :maxlength='maxlength'
                   class="normal-input__inner"
            >
        </template>
        <template v-else>
            <textarea ref="textarea"
                      :name="name"
                      :readonly="readonly"
                      :autofocus="autofocus"
                      :disabled="disabled"
                      :autocomplete="autocomplete"
                      :placeholder="placeholder"
                      :style="[resize ? resize:'']"
                      :value="value"
                      @blur="handleBlur"
                      @input="handleInput"
                      @change="handleChange"
                      @focus="handleFocus"
                       :maxlength='maxlength'
                      class="normal-textarea__inner"
            ></textarea>
            <pre class="textarea_pre" ref="textarea_pre"></pre>
        </template>
        <span class="normal-input__suffix"
                v-show="comSuffixIcon"
        >
            <i v-html="comSuffixIcon" @click="handlePrefixSuffixIcon('suffix')"></i>
        </span>
    </div>
</template>
<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';

    .normal-textarea {
        width: 100%;
        cursor: pointer;
        font-size: 14px;
        position: relative;

        &.danger {
            textarea {
                border: 1px solid @dangerBg;
            }
        }

        textarea {
            height: 100%;
            display: block;
            padding: 5px 10px;
            line-height: 1.5;
            box-sizing: border-box;
            width: 100%;
            font-size: inherit;
            color: @otherNormalTitleClr;
            background-color: @whiteBg;
            background-image: none;
            border: 1px solid @otherIptSelTipsDisbaledClr;
            border-radius: @widgetsBorderRadius;
            transition: border-color .2s cubic-bezier(.645, .045, .355, 1);

            &:focus {
                outline: none;
                border-color: @primaryBg;
            }
        }
    }

    .textarea_pre {
        font-size: 14px;
        color: #666666;
        line-height: 1.5;
        border: 1px solid #EBECEE;
        padding: 5px 15px;
        white-space: pre-wrap;
        width: 100%;
        box-sizing: border-box;
        position: absolute;
        left: -1000000px;
    }

    .normal-input, .normal-textarea {
        &.disabled {
            input, textarea {
                background-color: @otherDisabledBgClr !important;
                color: @otherBtnBorderNoteClr !important;
                border: 1px solid @otherBorderClr !important;
                cursor: not-allowed;
            }

            &__prefix, &__suffix {
                cursor: not-allowed;
            }
        }

        &__prefix, &__suffix {
            cursor: pointer;
            .user-select;
        }
    }

    .normal-input {
        position: relative;
        font-size: 14px;
        font-family: cmsicon;
        margin: ((@lineHeight - @widgetsHeight)/2) 0;
        cursor: pointer;

        &.danger {
            input {
                border: 1px solid @dangerBg;
            }

            &.normal-input-suffix {
                .normal-input__suffix {
                    i {
                        color: @dangerBg;
                    }
                }
            }
        }

        &.normal-input-suffix {
            input {
                padding-right: 30px;
            }
        }

        &.normal-input-prefix {
            input {
                padding-left: 30px;
            }
        }

        &__inner {
            -webkit-appearance: none;
            background-color: @whiteBg;
            background-image: none;
            border-radius: @widgetsBorderRadius;
            border: 1px solid @otherIptSelTipsDisbaledClr;
            box-sizing: border-box;
            color: @otherNormalTitleClr;
            display: inline-block;
            font-size: inherit;
            height: @widgetsHeight;
            line-height: @widgetsHeight;
            outline: none;
            padding: 0 10px;
            transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
            width: 100%;
            cursor: pointer;
            font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei UI", "Microsoft YaHei", '微软雅黑, Arial', 'sans-serif';

            &:focus {
                outline: none;
                border-color: @primaryBg;
            }
        }

        &__prefix {
            left: 5px;
        }

        &__suffix {
            right: 5px;
        }

        &__prefix, &__suffix {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 25px;
            text-align: center;
            color: @otherBtnBorderNoteClr;
            transition: all .3s;

            i {
                position: absolute;
                left: 50%;
                top: 50%;
                line-height: @widgetsHeight;
                height: @widgetsHeight;
                width: 25px;
                margin-left: -12.5px;
                margin-top: -18px;
                font-style: normal;
            }
        }
    }
</style>
